import React from 'react';
import Clients from '../components/Clients';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Portfolio from '../components/Portfolio';
import Services from '../components/Services';
import { useDocTitle } from '../components/CustomHook';
import CommonContainer from "../components/CommonContainer";


const Home = () => {
    useDocTitle("Quadprosoft Technologies inc");
    return (
        <>
        
            <Hero />
            <CommonContainer>
            <Intro />
            </CommonContainer>
            <Services />
            {/* <Portfolio /> */}
            {/* <Clients /> */}
            <Cta/>
            
        </>

    )
}

export default Home;

